<template>
  <v-dialog v-model="modal" persistent width="290px">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="value"
        :label="label"
        hide-details="auto"
        required
        readonly
        dense
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      :value="toIsoDate(value)"
      color="primary"
      scrollable
      @input="onDateInput"
    >
    </v-date-picker>
  </v-dialog>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },

    value: {
      type: String,
      required: true,
      validator: value => {
        // dd-mm-yyyy
        const apiDateFormat = /\d{2}-\d{2}-\d{4}/;
        return apiDateFormat.test(value);
      }
    }
  },

  data() {
    return {
      modal: false
    };
  },

  methods: {
    toIsoDate(date) {
      if (!date) return;

      const [d, m, y] = date.split("-");
      return [y, m, d].join("-");
    },

    toApiDate(date) {
      const [y, m, d] = date.split("-");
      return [d, m, y].join("-");
    },

    onDateInput(date) {
      this.$emit("input", this.toApiDate(date));
      this.modal = false;
    }
  }
};
</script>
